import React from "react";
import { Row, Col } from "antd";

function DestinationShipmentData({ destinationData }) {
  const {
    destinationName,
    destinationStreet,
    destinationPostalCode,
    destinationCity,
    destinationProvince,
  } = destinationData;
  return (
    <div>
      <h2>Datos Destinatario</h2>
      <Row>
        <Col span={10}>
          {" "}
          <h4>
            Nombre: <span className="shipment-info">{destinationName}</span>{" "}
          </h4>
        </Col>
        <Col span={8} offset={1}>
          {" "}
          <h4>
            Dirección:{" "}
            <span className="shipment-info">{destinationStreet}</span>{" "}
          </h4>
        </Col>
        <Col span={4} offset={1}>
          {" "}
          <h4>
            Código Postal:{" "}
            <span className="shipment-info">{destinationPostalCode}</span>{" "}
          </h4>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          {" "}
          <h4>
            Localidad: <span className="shipment-info">{destinationCity}</span>
          </h4>
        </Col>
        <Col span={8} offset={1}>
          <h4>
            Provincia:{" "}
            <span className="shipment-info">{destinationProvince}</span>
          </h4>
        </Col>
      </Row>
    </div>
  );
}

export default DestinationShipmentData;
